import { authUrl } from './endpoints'
import type { AuthMembership, AuthUser, LoginResponse } from './types'

async function postJSON<TReq, TRes>(path: string, body: TReq, init: RequestInit = {}): Promise<TRes> {
  const res = await fetch(authUrl(path), {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      ...(init.headers ?? {}),
    },
    body: JSON.stringify(body),
    ...init,
  })
  if (!res.ok) {
    let detail: unknown = undefined
    try { detail = await res.json() } catch { /* ignore */ }
    const err = new Error(`auth ${res.status}`) as Error & { status: number; detail?: unknown }
    err.status = res.status
    err.detail = detail
    throw err
  }
  return (await res.json()) as TRes
}

async function getJSON<TRes>(path: string, init: RequestInit = {}): Promise<TRes> {
  const res = await fetch(authUrl(path), {
    method: 'GET',
    credentials: 'include',
    headers: init.headers,
    ...init,
  })
  if (!res.ok) {
    const err = new Error(`auth ${res.status}`) as Error & { status: number }
    err.status = res.status
    throw err
  }
  return (await res.json()) as TRes
}

export const authClient = {
  login: (email: string, password: string) =>
    postJSON<{ email: string; password: string }, LoginResponse>('/auth/login', { email, password }),
  refresh: () =>
    postJSON<Record<string, never>, LoginResponse>('/auth/refresh', {} as Record<string, never>),
  logout: () =>
    postJSON<Record<string, never>, { status: string }>('/auth/logout', {} as Record<string, never>),
  me: (accessToken: string) =>
    getJSON<AuthUser & AuthMembership>('/auth/me', {
      headers: { Authorization: `Bearer ${accessToken}` },
    }),
}
